<template>
    <div class="content">
        <div class="content-head">
            <div class="content-head-title">搜索</div>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="订单日期">
                    <el-date-picker v-model="params.date_start" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.date_end" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getOfficeOrdersStatistics(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh" :loading="loadingBtn">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                <span>订单统计列表</span>
                <span style="color: #999999; font-size: 12px">注：此结果不包括已取消或交易失败订单</span>
            </div>
            <el-table  :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="tableData" :height="maxheight" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column prop="OwnerName" label="业务员" align="center"></el-table-column>
                <el-table-column prop="totalcount" label="签单数量" align="center">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="">{{ scope.row.totalcount }}个</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="totalamount" label="合同总额" align="center">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="">￥{{ scope.row.totalamount }}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import { myMixin } from '@/utils/mixin.js';
import { toLowerCaseKeys } from '@/utils/utils.js';
export default {
    mixins: [myMixin],
    components: {
        Pagination
    },
    name: 'orderStatistics',
    data() {
        return {
            loadingBtn: false,
            params: {},
            tableData: []
        };
    },
    mounted() {
        this.onRefresh();
    },
    methods: {
        /*
    重置查询
    */
        onRefresh() {
            (this.params = {
                date_start: '',
                date_end: ''
            }),
                this.getOfficeOrdersStatistics(true);
        },
        /*
    列表查询
    */
        getOfficeOrdersStatistics(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getOfficeOrdersStatistics(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = { ...this.params };
            return { json: JSON.stringify(toLowerCaseKeys(params)), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getOfficeOrdersStatistics();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getOfficeOrdersStatistics();
        }
    }
};
</script>

<style lang="scss" scoped></style>
